import { Helmet } from 'react-helmet';
import PageHeader from './Common/PageHeader';
import './ReturnPolicy.css';
const ReturnPolicy = () => {
  return (
    <>
      <Helmet>
        <title>
          Our return policy applies to new and existing Bakumia customers{' '}
        </title>
        <meta
          name="keywords"
          content="creative items,unique items,creative items to sell,creative craft items,creative gift items,creative home decor products,unique home accessories,best home decor gifts,unique kitchen decor,unique modern home decor,unique decorative items,unique house accessories,cheap home decor gifts,unique kitchen products,unique kitchenware itemsunique kitchen items,home and kitchen unique products,unique kitchen accessories,unique kitchen tools"
        />
        <meta
          name="description"
          content="We return products to all customers for valid reasons. If you find the product unfit for you, our customer service at Bakumia will be happy to assist you"
        />
      </Helmet>

      <PageHeader title="Return Policy" />
      <section className="policy-section py-3">
        <div className="container-fluid">
          <div className="text-center mb-5">
            <h2 className="fw-semibold">Return & Exchange Policy</h2>
            <div className="policy-divider"></div>
            <p className="text-muted mt-3">
              Please read our return, exchange, and cancellation policies
              carefully before making a purchase.
            </p>
          </div>

          <div className="policy-card mb-4">
            <h5 className="fw-bold mb-3">Return & Exchange</h5>
            <p>
              Any product bought from the online store at Bakumia can be
              exchanged within{' '}
              <strong style={{ color: '#965aa0' }}>7 days</strong> after
              receiving the product. The product must be undamaged, unused, in
              its original packaging, and accompanied by the original invoice.
            </p>
            <p>
              Items bought during sales cannot be exchanged. Product colors may
              vary due to lighting and cannot be exchanged for this reason.
            </p>
            <p>
              Exchanges are only accepted for damaged or defective products.
              Contact us at{' '}
              <strong style={{ color: '#965aa0' }}>
                (Insert Contact Number)
              </strong>{' '}
              within 7 days of delivery to arrange an exchange.
            </p>
          </div>

          <div className="policy-card mb-4">
            <h5 className="fw-bold mb-3">Refund Policy</h5>
            <p>
              Bakumia does not offer refunds except in exceptional cases, such
              as when an item goes out of stock. In such cases, the amount will
              be refunded to you.
            </p>
            <p>
              Shipping and handling costs are non-refundable and are not covered
              in case of an exchange.
            </p>
            <p>
              Returns take up to{' '}
              <strong style={{ color: '#965aa0' }}>7 days</strong> to process.
              Refunds will be issued after inspection and approval.
            </p>
          </div>

          <div className="policy-card">
            <h5 className="fw-bold mb-3">Order Cancellation</h5>
            <p>
              You may cancel your order before it is processed. Once shipped,
              you will receive a tracking ID and the order cannot be canceled.
            </p>
            <p>
              Bakumia reserves the right to cancel orders if items go out of
              stock, there is a pricing error, or if payment is declined.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
export default ReturnPolicy;
